export const COLORS = {
	blackish: '#4C4C4E',
	green: '#82D902',
	green2: '#cddc29',
	//green2: '#c0ec80',
	wsc_blue: '#00bacd',
	acid_green: '#ccdc29',
	navy: '#004a69',
	teal: '#009a91',
	blue: '#87D7FC',
	blue2: '#00BACD',
	blue3: '#c3e8ee',
	grey: '#C0C0C1',
	money: '#CDDC29',
	yellow: '#CDDC29',
	orange: '#dc9229',
	savings: '#3871FD',
	red: '#cc0000'
};

const WasteBrand = {
	screen: "unknown",
	brandColor: COLORS.wsc_blue,
	foreground: "#4D4D4F",
  xsm: "10px",
	sm: "12px",
	reg: "14px",
	med: "22px",
	lg: "36px",
	rounded: 0,
	input: { padding: "5px" },
	icons: [],
	fontFamily: "Red Hat Display"
};

export default WasteBrand;